import { render, staticRenderFns } from "./AppFooterPage.vue?vue&type=template&id=a7363a62&scoped=true&"
import script from "./AppFooterPage.vue?vue&type=script&lang=js&"
export * from "./AppFooterPage.vue?vue&type=script&lang=js&"
import style0 from "./AppFooterPage.vue?vue&type=style&index=0&id=a7363a62&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7363a62",
  null
  
)

export default component.exports